import React, { Component } from 'react';
import Button from '../Buttons/Button/Button';
// import HomeButton from '../Button/HomeButton/HomeButton';

import FlashModal from '../Modal/FlashModal/FlashModal';
import Input from '../Input/Input';

import axios from '../../../axios-drops';


import classes from './ContactPage.css';

class ContactPage extends Component {
    state = {
        contactForm: {
            name: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: ''
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Name'  
            },
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: ''
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false,
                name: 'Email'
            },
            message: {
                elementType: 'textarea',
                elementConfig: {
                    type: 'textarea',
                    placeholder: ' Message'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false
            }
        },
        formIsValid: false,
        loading: false,
        userIp: null,
        showModal: false
    }
    

    componentDidMount = async () => {

        let userIp = null

        await axios.get('https://api64.ipify.org?format=jsonp?callback=?')
                .then(response => {
                   
                    this.setState({userIp: response.data})
                })
    }

    clearAllFields = () => {
        let updatedForm = {...this.state.contactForm}

        updatedForm.name.value = ''
        updatedForm.email.value = ''
        updatedForm.message.value = ''

        updatedForm.name.valid = 'false'
        updatedForm.name.touched = 'false'

        updatedForm.email.valid = 'false'
        updatedForm.email.touched = 'false'

        updatedForm.message.valid = 'false'
        updatedForm.message.touched = 'false'

        this.setState({contactForm: updatedForm,
                        formIsValid: false
                        })
    }
    
    showModal = () => {
        this.setState({showModal: true})
    }

    hideModal = () => {
        this.setState({showModal: false})
    }

    modalHelper = () => {
        this.showModal()

        setTimeout(() => {
            this.hideModal() 
        }, 1000)
    }

    cancelClickedHandler = () => {
        // clear all fields in form 
        this.clearAllFields()
    }

    saveClickedHandler = props => {
    
        let ipStack = null

        const infoFunc = async () => {
            await axios.get('https://api.ipstack.com/' + this.state.userIp  + '?access_key=40d228e553d9a5083785cb6acb84d755')
            .then( res => {
                ipStack = res.data
                postFunc()
            })
        }

        infoFunc()

        const postFunc = async () => {
            const date = new Date();
            // 7 hourse later than pst time
            const dateFinal = date.toJSON().slice(0,10).replace(new RegExp("-", 'g'),"/" ).split("/").reverse().join("/")+" "+date.toJSON().slice(11,19);

            const uploadMessage = {
                ip: this.state.userIp,
                name: this.state.contactForm.name.value,
                email: this.state.contactForm.email.value,
                message: this.state.contactForm.message.value,
                date:  dateFinal,
                ipStack: ipStack
                    // number of miliseconds since midnight jan 1st 1970
            }
            
            axios.post('/contact/messages.json', uploadMessage)
            .then(response => {
                // thanks for submitting a message modal 
                this.modalHelper()
                // stay on page but clear all text fields
                this.clearAllFields()
            }).catch(error => console.log(error));
        }
    }

    checkValidity(value, rules) {
        
        let isValid = true;

        if(rules.required){
            isValid = value.trim() !== '';     
        }

        return isValid;
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedContactForm = {
            ...this.state.contactForm
        }


        const updatedFormElement = {
            ...updatedContactForm[inputIdentifier]
        }

        // console.log(updatedFormElement)
        updatedFormElement.value = event.target.value;

        // console.log(updatedFormElement)

        updatedFormElement.valid = this.checkValidity(
            updatedFormElement.value, updatedFormElement.validation
        )
        updatedFormElement.touched = true;
        // console.log(updatedFormElement);

        updatedContactForm[inputIdentifier] = updatedFormElement;
        // console.log(updatedInputForm)
        let formIsValid = true;
        for( let inputIdentifier in updatedContactForm){
            formIsValid = updatedContactForm[inputIdentifier].valid
            && formIsValid;
        }

        this.setState({contactForm: updatedContactForm,
                        formIsValid: formIsValid});

    }


    render(){

        // console.log(this.state.contactForm)
        const formElementsArray = [];
        for (let key in this.state.contactForm){
            formElementsArray.push({
                id: key,
                config: this.state.contactForm[key]
            })
        }

        // console.log(formElementsArray)

        let form = (
            <form onSubmit={this.contactMessageHandler}>
                {formElementsArray.map(formElement => (
                    <Input key={formElement.id}
                    elementType={formElement.config.elementType} 
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    name={formElement.config.name}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    touched={formElement.config.touched}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}/>
                ))}

                {/* <Button btnType="Success" disabled={!this.state.formIsValid}
                >ORDER</Button> */}

            </form>
        )
        // console.log(form)

        return (
            <div className={classes.ContactPage}>
                
                {/* <h1>Contact Us</h1> */}
                <p className={classes.Prompt}>Questions? Concerns? Let us know!
                </p>
                {form}
                <div className={classes.BottomArea}>
                    <Button btnType="Cancel"
                        clicked={this.cancelClickedHandler}>
                        CANCEL
                    </Button>
                    <div className={classes.SpaceBetween}></div>
                    <Button btnType="Submit" disabled={!this.state.formIsValid}
                        clicked={this.saveClickedHandler}>
                        SUBMIT
                    </Button>
                </div>
                <FlashModal show={this.state.showModal}>
                    Success!
                </FlashModal>
                {/* <FlashModal show={true} >Success!</FlashModal>   */}
            </div>
        )
    }
    
}

export default ContactPage;


// WEBPACK FOOTER //
// ./src/components/UI/ContactPage/ContactPage.js